import React from "react";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { withShowIf } from "../../with-show-if/with-show-If.component";
import { HostContainer } from "./drawer-expand-button.styles";
import { DrawerControlButtonProps } from "../types/drawer-control-button.props";
export const DrawerExpandButton = withShowIf((props: DrawerControlButtonProps) => (
  <HostContainer variant="filled" onClick={props.onClick}>
    <ChevronLeftIcon />
  </HostContainer>
));
